import {
  PHOTO_IMAGE,
  PHOTO_TITLE,
  PHOTO_TIME_NUM,
  PHOTO_RATING_NUM,
  PHOTO_COMMENT_LIST,
  PHOTO_COMMENT_EXAMPLE,
} from "../constants"

import AuthorEntity from "./author-entity"
import CommentEntity from "./comment-entity"

class PhotoEntity {
  constructor({ id, title, description, url, imageUrls, timestamp, stars, author, comments }) {
    this.id = id
    this.title = title
    this.description = description
    this.url = url
    this.imageUrls = imageUrls || {}
    this.timestamp = timestamp
    this.stars = stars
    this.author = author
    this.comments = comments
  }

  copyWith({ id, title, description, url, imageUrls, timestamp, stars, author, comments }) {
    return new PhotoEntity({
      id: id === undefined ? this.id : id,
      title: title === undefined ? this.title : title,
      description: description === undefined ? this.description : description,
      url: url === undefined ? this.url : url,
      imageUrls: imageUrls === undefined ? this.imageUrls : imageUrls,
      timestamp: timestamp === undefined ? this.timestamp : timestamp,
      stars: stars === undefined ? this.stars : stars,
      author: author === undefined ? this.author : author,
      comments: comments === undefined ? this.comments : comments,
    })
  }

  // Create from JSON API response
  static fromJson(json) {
    return new PhotoEntity({
      id: json.id,
      title: json.title,
      description: json.descr,
      url: json.url,
      imageUrls: json.image_urls || {},
      timestamp: json.taken_at && Date.parse(json.taken_at),
      stars: json.num_stars,
      author: AuthorEntity.FromJson(json),
      comments: json.comments.map(CommentEntity.fromJson),
    })
  }

  // Create from initial HTML
  static fromHtmlElement(htmlElement) {
    const imageElement = htmlElement.querySelector(PHOTO_IMAGE)
    const titleElement = htmlElement.querySelector(PHOTO_TITLE)
    const timestampElement = htmlElement.querySelector(PHOTO_TIME_NUM)
    const starsElement = htmlElement.querySelector(PHOTO_RATING_NUM)
    const commentListElement = htmlElement.querySelector(PHOTO_COMMENT_LIST)

    // Extract just the photo title from data attribute, not the full formatted string
    const photoTitle = titleElement?.dataset.photoTitle || ""

    return new PhotoEntity({
      id: Number(imageElement.dataset.photoId),
      title: photoTitle,
      description: "",
      url: imageElement.currentSrc || imageElement.src,
      timestamp:
        timestampElement && timestampElement.dataset.date
          ? Number(timestampElement.dataset.date)
          : null,
      stars: starsElement ? Number(starsElement.textContent) || null : null,
      author: AuthorEntity.fromHtmlElement(htmlElement),
      comments: commentListElement
        ? Array.from(commentListElement.querySelectorAll(`li:not(${PHOTO_COMMENT_EXAMPLE})`)).map(
            CommentEntity.fromHtmlElement,
          )
        : [],
    })
  }
}

export default PhotoEntity
